import { render, staticRenderFns } from "./my_own.vue?vue&type=template&id=2f502198&scoped=true"
import script from "./my_own.vue?vue&type=script&lang=js"
export * from "./my_own.vue?vue&type=script&lang=js"
import style0 from "./my_own.vue?vue&type=style&index=0&id=2f502198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f502198",
  null
  
)

export default component.exports